export default __webpack_public_path__ + "static/media/LockedPost.0c624db5.svg";